// Display-only allowlist. Frozen evidence is never changed or rendered verbatim.
const STATE_NAMES={fl:'Florida',ga:'Georgia',tx:'Texas',ny:'New York',pa:'Pennsylvania',oh:'Ohio',mi:'Michigan',il:'Illinois',ca:'California',nc:'North Carolina'};
const SESSIONS={midday:'Midday',evening:'Evening',morning:'Morning',night:'Night'};
const date=x=>typeof x==='string'&&/^\d{4}-\d{2}-\d{2}$/.test(x)?x:null;
const count=x=>Number.isInteger(x)&&x>=0?x:null;
function travelingExplanation(pick){
 const e=pick.frozenEvidence||{};
 const states=Array.isArray(e.states)?[...new Set(e.states.map(x=>STATE_NAMES[String(x).toLowerCase()]).filter(Boolean))]:[];
 const trail=Array.isArray(e.trail)?e.trail.flatMap(x=>{
  if(!x||typeof x!=='object')return [];
  const state=STATE_NAMES[String(x.state_code||x.state||'').toLowerCase()],day=date(x.draw_date||x.date),session=SESSIONS[x.session];
  return state&&day&&session?[{state,date:day,session,straight:typeof (x.main_digits||x.straight)==='string'&&/^\d{3}$/.test(x.main_digits||x.straight)?(x.main_digits||x.straight):null}]:[];
 }):[];
 return {straight:pick.straight,family:pick.family,states,stateCount:count(e.stateCount),appearanceCount:count(e.appearanceCount),lastSeenDate:date(e.lastSeenDate),freshnessDays:count(e.freshnessDays),trail};
}
module.exports={travelingExplanation};

